var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.visible),expression:"visible"}],staticClass:"box-select-preview",class:{ 'remove-mode': _setup.removeMode },style:(_setup.cssVariables)})
}
var staticRenderFns = []

export { render, staticRenderFns }